// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dim--card {
  background-color: white;
}
.dim--card .s-14 {
  font-size: 14px;
}
.dim--card .dim--card--arrow {
  color: var(--surface-100);
}
.dim--card .dim--card--arrow-active {
  color: var(--primary-color);
  font-weight: 700;
}

.dim--card-active {
  color: var(--primary-color);
  font-weight: 700;
}

.test {
  background-color: #22C55E;
  color: white;
}

h2 {
  color: var(--primary-color);
}

.section-container {
  background-color: white;
  color: var(--text-color);
  border-radius: 8px;
  padding: 0.5rem;
}

.select-button {
  border: none;
  background-color: none;
  color: var(--primary-color);
  margin-top: 10px;
  cursor: pointer;
  transition: color 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease;
}

.select-button:hover {
  color: var(--primary-700);
}

.highlight-containner {
  background-color: #F7F8F9;
  margin: -16px -16px 16px -16px;
}
.highlight-containner .highlight-section {
  background-color: #F7F8F9;
  padding: 2rem 3rem;
}
.highlight-containner .highlight-section .highlight-icon {
  color: #6C757D;
}

.custom-tooltip {
  max-width: 400px;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/questionnaire-sections/common-page/common-page.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;AACI;EACI,eAAA;AACR;AAEI;EACI,yBAAA;AAAR;AAGI;EACI,2BAAA;EACA,gBAAA;AADR;;AAKA;EACI,2BAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,YAAA;AAFJ;;AAcA;EACI,2BAAA;AAXJ;;AAcA;EACI,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;AAXJ;;AAcA;EACI,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,6EAAA;AAXJ;;AAcA;EACI,yBAAA;AAXJ;;AAcA;EACI,yBAAA;EACA,8BAAA;AAXJ;AAaI;EACI,yBAAA;EACA,kBAAA;AAXR;AAaQ;EACI,cAAA;AAXZ;;AAgBA;EACI,gBAAA;EACA,aAAA;AAbJ","sourcesContent":[".dim--card {\n    background-color: white;\n\n    .s-14 {\n        font-size: 14px;\n    }\n\n    .dim--card--arrow {\n        color: var(--surface-100);\n    }\n\n    .dim--card--arrow-active {\n        color: var(--primary-color);\n        font-weight: 700;\n    }\n}\n\n.dim--card-active {\n    color: var(--primary-color);\n    font-weight: 700;\n}\n\n.test {\n    background-color: #22C55E;\n    color: white;\n}\n\n\n// .material-symbols-outlined {\n//     font-variation-settings:\n//         'FILL' 1,\n//         'wght' 400,\n//         'GRAD' 0,\n//         'opsz' 24\n// }\n\nh2 {\n    color: var(--primary-color);\n}\n\n.section-container {\n    background-color: white;\n    color: var(--text-color);\n    border-radius: 8px;\n    padding: 0.5rem;\n}\n\n.select-button {\n    border: none;\n    background-color: none;\n    color: var(--primary-color);\n    margin-top: 10px;\n    cursor: pointer;\n    transition: color 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.select-button:hover {\n    color: var(--primary-700);\n}\n\n.highlight-containner {\n    background-color: #F7F8F9;\n    margin: -16px -16px 16px -16px;\n\n    .highlight-section {\n        background-color: #F7F8F9;\n        padding: 2rem 3rem;\n\n        .highlight-icon {\n            color: #6C757D\n        }\n    }\n}\n\n.custom-tooltip {\n    max-width: 400px;\n    padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
